import Character from './Character';

export default class Shaggy extends Character {
  constructor(game, x, y) {
    super(game, 'shaggy', Shaggy.OFFSETS);

    this.x = x;
    this.y = y;

    this.arm.x = x - 83;
    this.arm.y = y + 50;
    this.hand.x = x - 40;
    this.hand.y = y + 10;
  }
}

Shaggy.OFFSETS = {
  idle: { x: 0, y: 0 },
  lean_front: { x: 0, y: 0 },
  lean_back: { x: 0, y: 0 },
  nod: { x: -8, y: 0 },
  duck: { x: -4, y: 0 },
  sad: { x: 0, y: 0 },
  eat: { x: 4, y: 0 },
};



// WEBPACK FOOTER //
// ./js/app/games/food/Shaggy.js